import { useState, useEffect, useCallback } from 'react';
import { UseUserOrderInitReturn } from './UserOrderTypes';

/**
 * User Order Initialization Hook
 * Handles user order initialization logic and lifecycle
 */

export const useUserOrderInit = (
  userId: number | null,
  fetchOrdersSummary: (limit?: number) => Promise<void>,
  fetchOrderStats: () => Promise<void>
): UseUserOrderInitReturn => {
  const [hasInitialized, setHasInitialized] = useState(false);

  // Reset initialization flag when userId changes
  useEffect(() => {
    setHasInitialized(false);
  }, [userId]);

  // Initialize user orders data when user ID is available
  const initializeUserOrders = useCallback(() => {
    if (userId && !hasInitialized) {
      fetchOrdersSummary();
      fetchOrderStats();
      setHasInitialized(true);
    }
  }, [userId, hasInitialized, fetchOrdersSummary, fetchOrderStats]);

  // Auto-initialize when conditions are met
  useEffect(() => {
    initializeUserOrders();
  }, [initializeUserOrders]);

  return {
    hasInitialized,
    setHasInitialized,
    initializeUserOrders,
  };
};
